<template>
    <div class="ticket-bottom-div">
        <a target="_blank" href="/ticket-vue/about">工单系统</a>
        <span>by</span>
        <a target="_blank" href="//www.itaojin.cn">淘金你我</a>
        <span>@2021</span>
    </div>
</template>

<script>
export default {
  name: "TicketBottom",
}
</script>

<style scoped>
  .ticket-bottom-div {
    position:fixed;
    bottom:0;
    width: 100vw;
    text-align: center;
    height:30px;
    color:#c7c392;
    margin: 0 auto;
    filter: brightness(70%) drop-shadow(1px 1px 10px #707070);
  }
</style>



// WEBPACK FOOTER //
// src/components/ticket/TicketBottom.vue